import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import { ADDRESS_MODEL_CLASS_NAME } from 'models/daos/address/constants'
import { ARTICLE_MODEL_CLASS_NAME } from 'models/daos/article/constants'
import { COMMENT_MODEL_CLASS_NAME } from 'models/daos/comment/constants'
import { EMAIL_TEMPLATE_MODEL_CLASS_NAME } from 'models/daos/email-template/constants'
import { LOG_MODEL_CLASS_NAME } from 'models/daos/log/constants'
import { MOTIVATION_MODEL_CLASS_NAME } from 'models/daos/motivation/constants'
import { NOTIFICATION_MODEL_CLASS_NAME } from 'models/daos/notification/constants'
import { ORDER_MODEL_CLASS_NAME } from 'models/daos/order/constants/index.cjs'
import { SETTINGS_MODEL_CLASS_NAME } from 'models/daos/settings/constants'
import { PAGE_MODEL_CLASS_NAME } from 'models/daos/page/constants'
import { PRODUCT_MODEL_CLASS_NAME } from 'models/daos/product/constants'
import { PROMO_CODE_MODEL_CLASS_NAME } from 'models/daos/promo-code/constants'
import { REPORT_MODEL_CLASS_NAME } from 'models/daos/report/constants'
import { TOKEN_MODEL_CLASS_NAME } from 'models/daos/token/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'
import { EXERCISE_CLASS_NAME } from 'modules/training/models/exercise/constants'
import { invertObjectUtil } from 'packages/src'

const MODEL_CLASS_NAME_TO_SECTION = {
  [ADDRESS_MODEL_CLASS_NAME]: SECTIONS_NAME.ADDRESS,
  [ARTICLE_MODEL_CLASS_NAME]: SECTIONS_NAME.ARTICLES,
  [COMMENT_MODEL_CLASS_NAME]: SECTIONS_NAME.COMMENTS,
  [EMAIL_TEMPLATE_MODEL_CLASS_NAME]: SECTIONS_NAME.EMAIL_TEMPLATES,
  [LOG_MODEL_CLASS_NAME]: SECTIONS_NAME.LOGS,
  [MOTIVATION_MODEL_CLASS_NAME]: SECTIONS_NAME.MOTIVATION,
  [NOTIFICATION_MODEL_CLASS_NAME]: SECTIONS_NAME.NOTIFICATIONS,
  [ORDER_MODEL_CLASS_NAME]: SECTIONS_NAME.ORDERS,
  [SETTINGS_MODEL_CLASS_NAME]: SECTIONS_NAME.SETTINGS,
  [PAGE_MODEL_CLASS_NAME]: SECTIONS_NAME.PAGES,
  [PRODUCT_MODEL_CLASS_NAME]: SECTIONS_NAME.STORE,
  [PROMO_CODE_MODEL_CLASS_NAME]: SECTIONS_NAME.PROMO_CODES,
  [REPORT_MODEL_CLASS_NAME]: SECTIONS_NAME.REPORTS,
  [TOKEN_MODEL_CLASS_NAME]: SECTIONS_NAME.TOKENS,
  [USER_MODEL_CLASS_NAME]: SECTIONS_NAME.USERS,
  [EXERCISE_CLASS_NAME]: SECTIONS_NAME.EXERCISES
}

const MODEL_SECTION_TO_CLASS_NAME = invertObjectUtil(MODEL_CLASS_NAME_TO_SECTION)

export {
  MODEL_CLASS_NAME_TO_SECTION,
  MODEL_SECTION_TO_CLASS_NAME
}
